import React from 'react'
import Menu from './FooterMenu'

const FooterMenu = () => (
  <Menu/>
)

export default FooterMenu



// WEBPACK FOOTER //
// ./src/components/FooterMenu/index.js